import React from "react";
import styled from "styled-components";
import Grid from "../Layout/Grid";
import Button from "../Button/Button";
import Input from "../Input/Input";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import icon from "@fortawesome/fontawesome-free-solid/faSearch";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.placeholder = props.placeholder;
    this.description = props.description;
  }
  render() {
    const children = this.props.children;
    return (
      <Component theme={this.props.theme}>
        <Grid>
          <Input placeholder={this.placeholder} type="text" />
          <Button style={{ width: "auto" }}>
            <FontAwesomeIcon icon={icon} />
          </Button>
        </Grid>
        {children}
      </Component>
    );
  }
}

const Component = styled.div`
  display: inline-block;
  width: 100%;
  max-width: 632px;
  font-size: 14px;
  color: ${props => (props.theme === "dark" ? "white" : false)};
  text-shadow: ${props =>
    props.theme === "dark" ? "0 2px 5px #215a65, 0 0px 15px #444" : false};

  ${Input}, ${Button} {
    height: 48px;
  }

  ${Grid} {
    margin-bottom: 8px;
  }
  a {
    background: rgba(255, 255, 255, 0.8);
    color: #000 !important;
    padding: 3px 6px;
    border-radius: 3px;
    text-decoration: none;
    border: 0;
    text-shadow: 0 0 5px white;

    &:hover {
      background: rgba(255, 255, 255, 1);
    }
  }
`;

export default Search;



// WEBPACK FOOTER //
// ./src/UI/Search/Search.js